export const randStr = (length: number, randChar: () => string) => {
  let r = ''
  for (let i = 0; i < length; i += 1) r += randChar()
  return r
}

export const randDigit = (base = 10) =>
  ((Math.random() * base) << 0).toString(base)

export const randInt = (length: number) => randStr(length, randDigit)
export const randHex = (length: number) => randStr(length, () => randDigit(16))
export const randBase36 = (length: number) =>
  randStr(length, () => randDigit(36))

/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
 * @returns a pseudo-number generated using crypto API
 */
export const getRandomSeed = (): number => {
  const arr = new Uint32Array(1)
  self.crypto.getRandomValues(arr)
  return arr[0]
}
